import { render, staticRenderFns } from "./tencenttargetings.vue?vue&type=template&id=31d2624c&"
import script from "./tencenttargetings.vue?vue&type=script&lang=js&"
export * from "./tencenttargetings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports